module.exports = __webpack_public_path__ + "img/时间@2x.6004a539.png";